var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.277252C4.71012 0.277252 0 4.98738 0 10.7773C0 16.5671 4.71012 21.2773 10.5 21.2773C16.2899 21.2773 21 16.5671 21 10.7773C21 4.98738 16.2899 0.277252 10.5 0.277252ZM15.925 9.47525L12.0522 13.2771C11.3671 13.9491 10.4851 14.2843 9.60225 14.2843C8.729 14.2843 7.85575 13.9553 7.17325 13.2964L5.51162 11.6628C5.16687 11.3241 5.1625 10.7703 5.50113 10.4255C5.83888 10.0799 6.3945 10.0755 6.73838 10.415L8.39475 12.0434C9.07375 12.6996 10.1456 12.6961 10.8281 12.0276L14.7 8.22663C15.0439 7.88713 15.596 7.89325 15.9373 8.238C16.2759 8.58275 16.2706 9.13663 15.925 9.47525Z",
    fill: "#428D56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidIcon);
export default __webpack_public_path__ + "static/media/paid-icon.a36fa73c3cdadc8d358138352fb9f46b.svg";
export { ForwardRef as ReactComponent };